package net.frozenbit.games.soundgame.components

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.unit.dp
import net.frozenbit.games.soundgame.theme.secondaryContainerLight

@Composable
internal fun QuarterArc(
    modifier: Modifier = Modifier,
) {
    Canvas(
        modifier = modifier
            .size(400.dp)
            .alpha(0.3f)
    ) {
        drawArc(
            color = secondaryContainerLight,
            startAngle = -90f,
            sweepAngle = 90f,
            useCenter = true,
            topLeft = Offset(-size.width, 0f),
            size = Size(size.width * 2, size.height * 2),
        )
    }
}